var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareInvitationLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 3.33317L9.72008 4.27984L8.66008 3.21984V10.6665H7.34008V3.21984L6.28008 4.27984L5.33341 3.33317L8.00008 0.666504L10.6667 3.33317ZM13.3334 6.6665V13.9998C13.3334 14.7332 12.7334 15.3332 12.0001 15.3332H4.00008C3.26008 15.3332 2.66675 14.7332 2.66675 13.9998V6.6665C2.66675 5.9265 3.26008 5.33317 4.00008 5.33317H6.00008V6.6665H4.00008V13.9998H12.0001V6.6665H10.0001V5.33317H12.0001C12.7334 5.33317 13.3334 5.9265 13.3334 6.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareInvitationLink);
export default __webpack_public_path__ + "static/media/share_invitation_link.62e435e9d1c612b3ecaad3f69d6f75bd.svg";
export { ForwardRef as ReactComponent };